import { configureStore } from "@reduxjs/toolkit";
import hotelSlice from "./store/slice/hotelSlice";
import userSlice from "./store/slice/userSlice";

export const store = configureStore({
  reducer: {
    hotelData: hotelSlice,
    user: userSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
